import {Component, OnInit, Input, ViewChildren, QueryList, AfterViewInit} from '@angular/core';
import { AutoGroupDropdown } from '../../../../../models/group-settings';
import { AutoGroupFilterItemComponent } from './auto-group-filter-item/auto-group-filter-item.component';
import { ErrorTemplate } from '../../../../../models/ErrorTemplate';
import {
  AutoGroupComparisonConfig, AutoGroupFilter,
  AutoGroupFilterConfig, AutoGroupFilterEnum
} from '../../../../../models/auto-group/auto-group-setting';
import {ObjectUtils} from '../../../../utils/object.utils';
import {TranslateService} from '@ngx-translate/core';
import {ReferenceDataService} from '../../../../services/reference-data/reference-data.service';

@Component({
  selector: 'auto-group-filters',
  templateUrl: './auto-group-filters.component.html',
  styleUrls: ['./auto-group-filters.component.scss']
})
export class AutoGroupFiltersComponent implements OnInit, AfterViewInit {

  @ViewChildren(AutoGroupFilterItemComponent) autoGroupFilterItemList: QueryList<AutoGroupFilterItemComponent>;

  @Input() supportedFilterOptions: Array<AutoGroupDropdown> = [];
  @Input() autoGroupFilters: AutoGroupFilter[] = [];

  public availableFilterTypeOptions: Array<AutoGroupDropdown> = [];

  constructor(private translate: TranslateService, private referenceData: ReferenceDataService) { }

  ngOnInit() {
    this.availableFilterTypeOptions = ObjectUtils.deepClone(this.supportedFilterOptions);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.autoGroupFilterItemList.forEach(filterItem => this.onChangeGroupFilter(filterItem.autoGroupFilter));
    }, 100);
  }

  addMoreGroupFilter() {
    const newFilter = new AutoGroupFilter();
    const maxIndex = Math.max(...this.autoGroupFilters.map(a => a.index), 0);
    newFilter.index = maxIndex + 1;
    this.autoGroupFilters.push(newFilter);
  }

  deleteGroupFilterEvent(evt) {
    const deletedIndex = this.autoGroupFilters.findIndex(ag => ag.index === evt.index);
    this.autoGroupFilters.splice(deletedIndex, 1);
    this.onChangeGroupFilter(evt, true);
  }

  validateAllFilters(): ErrorTemplate[] {
    const filterErrors = [];
    this.autoGroupFilterItemList.forEach(filter => filterErrors.push(...filter.validateFilters()));
    return filterErrors;
  }

  onChangePlatform(selectedPlatform) {
    const impactedFilterByPlatform = [AutoGroupFilterEnum.FOLLOWERS, AutoGroupFilterEnum.AVG_INTERACTION_PER_POST, AutoGroupFilterEnum.AVG_REACH_PER_POST, AutoGroupFilterEnum.AVG_ENGAGEMENT_PER_POST];
    const updatingFilterComps = this.autoGroupFilterItemList.filter(ac => impactedFilterByPlatform.indexOf(ac.autoGroupFilter.type) >= 0);
    updatingFilterComps.forEach(comp => comp.updateWarningMessage(selectedPlatform));
  }

  onChangeGroupFilter(filter: AutoGroupFilter, isDeleted = false) {
    if (!filter.type) {
      return;
    }
    this.calculateFilterTypeOptions();
    const updatingFilterComps = this.autoGroupFilterItemList.filter(ac => ac.autoGroupFilter.type === filter.type);
    updatingFilterComps.forEach(filterComp => filterComp.updateOperatorList(this.getOperatorList(filterComp.autoGroupFilter)));

    if (isDeleted) {
      if (filter.type === AutoGroupFilterEnum.PLATFORM) {
        this.onChangePlatform(null);
      }
    } else {
      const platformFilter = this.autoGroupFilterItemList.find(comp => comp.autoGroupFilter.type === AutoGroupFilterEnum.PLATFORM);
      if (!platformFilter) {
        this.onChangePlatform(null);
      } else {
        const selectedPlatform = this.referenceData.platforms.find(p => p.id === platformFilter.autoGroupFilter.secondValue);
        if (!selectedPlatform) {
          this.onChangePlatform(null);
        } else {
          this.onChangePlatform(selectedPlatform.name);
        }
      }
    }
  }

  private calculateFilterTypeOptions() {
    const selectedFilterTypes = this.autoGroupFilters.map(gf => gf.type);
    this.availableFilterTypeOptions = this.supportedFilterOptions.filter(sf => this.isValidFilterType(sf, selectedFilterTypes));
  }

  private isValidFilterType(filterType, selectedFilterTypes: number[]) {
    const filterConfig = AutoGroupFilterConfig[filterType.id];
    const numOfSelectedFilterType = selectedFilterTypes.filter(s => s === filterType.id).length;
    return filterConfig && (numOfSelectedFilterType < filterConfig.comparison.length);
  }

  private getOperatorList(filter: AutoGroupFilter) {
    if (!filter) {
      return [];
    }
    const filterConfig = AutoGroupFilterConfig[filter.type];
    if (!filterConfig) {
      return [];
    }
    const supportedOperators = filterConfig.comparison.map(comp => AutoGroupComparisonConfig[comp]);
    // operator is selecting by this filter
    const selectedOperator = supportedOperators.find(so => so.id === filter.comparison);
    // get list operators which can not be used
    const invalidOperators = this.autoGroupFilters.filter(f => f.type === filter.type)
      .map(sgf => sgf.comparison);
    // get valid operators
    let validOperators = supportedOperators.filter(so => invalidOperators.indexOf(so.id) < 0);
    if (selectedOperator) {
      validOperators = validOperators.concat(selectedOperator);
    }
    return validOperators.map(com => {
      const operatorLabel = this.translate.instant(`new_group_settings.comparison.${com.key}`);
      return {
        id: com.id,
        name: operatorLabel,
        value: operatorLabel,
        op: com.operator
      };
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/auto-group-filters/auto-group-filters.component.ts